import React, {ChangeEvent, MouseEventHandler, useEffect, useState} from "react";
import Box from "@mui/material/Box";
import {
    Button,
    Grid, InputBase,
    MenuItem, Pagination,
    Paper, styled,
    Typography
} from "@mui/material";
import { Icon } from '@iconify/react';
import IconButton from "@mui/material/IconButton";
import services from "../../services";
import {UsersDataTable} from "../../components/datatables/UsersDataTable";


interface Users{
    createdAt: string
    dob: string
    email: string
    first_name: string
    id: number
    last_name: string
    role_id: number
    updatedAt: string
}

export const AllAdmins = () => {

    const [skeleton,setSkeleton] = useState<boolean>(false)

    const [admins,setAdmins] = useState<Users[]>([])

    useEffect(()=>{
        setSkeleton(true)
        services
            .GetAdminsList()
            .then(res=> {
                let i = 1
                res.data.forEach((d:any)=>{
                    d.uniqueId = i++
                    d.dob = new Date(d.dob).toLocaleDateString()
                })
                setAdmins(res.data)
                setSkeleton(false)
            })
            .catch(error=> {
                setSkeleton(false)
            })
    },[])

    return (
        <Box sx={{flexGrow: 1, padding: "0px 30px"}}>
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                paddingTop={1}
                paddingBottom={4}
            >
                <Grid xs={6} item>
                    <Typography
                        fontSize={32}
                        fontWeight={700}
                        color="#081735"
                    >
                        Admins
                    </Typography>
                </Grid>
            </Grid>
            <UsersDataTable showFooter={false} data={admins} height={700} skeleton={skeleton} hideActionsColumn={true}/>
        </Box>
    )
}


